import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug } from '@fortawesome/free-solid-svg-icons'

// Message for a follow-up fetch inside an already-rendered card (a table's "Load more"
// or a sort), where replacing the whole card body with `CardError` would throw away rows
// the user is still reading. Like `CardError`, it states what failed without the raw
// server reason — callers log that to the console instead.
function InlineFetchError({ message, className = '' }) {
  return (
    <div className={`text-danger small ${className}`.trim()} role="alert" data-testid="inline-fetch-error">
      <FontAwesomeIcon icon={faBug} className="me-1" />
      {message}
    </div>
  )
}

InlineFetchError.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default InlineFetchError
